/**
 * NAPAI program leadership roster shown in the homepage's institutional
 * trust section (PR-117). Each entry links to that person's own official
 * academic homepage — not a generic department page — so the accessible
 * name and CTA can state a real destination ("前往 {{name}} 的個人網頁").
 */
export const programTeam = [
  {
    key: 'chchang',
    roleKey: 'pi',
    url: 'https://sites.google.com/site/nculab/advisor',
    photo: '/brand/team/chchang.jpg',
  },
  {
    key: 'myday',
    roleKey: 'coPi',
    url: 'https://web.ntpu.edu.tw/~myday/',
    photo: '/brand/team/myday.jpg',
  },
  {
    key: 'mchu',
    roleKey: 'coPi',
    url: 'https://mislab.cs.nthu.edu.tw/',
    photo: '/brand/team/mchu.jpg',
  },
] as const

export type ProgramTeamKey = (typeof programTeam)[number]['key']
